import type { SupportDepartment } from './types';

export const SUPPORT_DEPARTMENTS: SupportDepartment[] = [
  { id: 'Finance', label: 'Finance' },
  { id: 'HR', label: 'HR' },
  { id: 'Marketing', label: 'Marketing' },
  { id: 'Property Management', label: 'Property Management' },
  { id: 'IT', label: 'IT' },
  { id: 'PRCR Warehouse', label: 'PRCR/ Warehouse' },
  { id: 'Purchasing', label: 'Purchasing' },
  { id: 'Operations', label: 'Operations' },
  { id: 'App', label: 'Arb' },
];
